import { EventViewLayout } from '@unistocks/features/dashboard/components/dashboard-data/event-view/layout';
import { EventViewCarousel } from '@unistocks/features/dashboard/components/dashboard-data/event-view/layouts/carousel';
import { EventViewList } from '@unistocks/features/dashboard/components/dashboard-data/event-view/layouts/list';
import { DashboardItemProps } from '@unistocks/features/dashboard/components/dashboard-item/dashboard-item';
import React from 'react';

export const EventView: React.FC<DashboardItemProps> = ({ item, openSettings, ...frameProps }) => {
  const { settings } = item;
  const layout: EventViewLayout = settings.layout;

  return layout === EventViewLayout.Carousel ? (
    <EventViewCarousel item={item} openSettings={openSettings} {...frameProps} />
  ) : (
    <EventViewList item={item} openSettings={openSettings} {...frameProps} />
  );
};
